import { parse as uuidParse } from "uuid";

export const isValidUuidForKeywordGroup = (key: string): boolean => {
    /**
     * check if the key is a valid uuid
     * this is a heuristic since we can't an async call to getGroupById in getProUrl()
     */
    try {
        return !!uuidParse(key);
    } catch (_error) {
        return false;
    }
};
